<template>
  <section class="h-full w-full flex flex-col">
        <div :style="backgroundStyle" class="ht-auto sm:ht-300 md:ht-350 lg:ht-400 xl:ht-500 2xl:ht-600 w-full bg-cover bg-no-repeat bg-center relative bg-image">
        </div>
        <div class="w-full mt-8 px-8">
            <div class="container mx-auto">
            <bread-crumb :items="breadCrumbItems"></bread-crumb>
            </div>
        </div>
        <div class="px-8 my-8" v-if="$apollo.queries.successStories.loading">
            <div class="container mx-auto">
                <div class="bg-1 h-12 animate-pulse"></div>
                <div>
                    <story-card-shimmer class="mt-8"></story-card-shimmer>
                    <hr class="mt-8 border-primary animate-pulse">
                    <div class="mt-8">
                        <p v-for="(i, index) in 10" :key="index" class="h-4 bg-gray-300 animate-pulse mb-4"></p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="px-8 my-8">
            <div class="container mx-auto">
                <div class="bg-1 text-white px-4 py-2 text-2xl font-bold flex items-center">
                    <icon-back @click.stop="$router.go(-1)" class="zoom-in"></icon-back>
                    <h1 class="ml-2">{{ getHeaderText }}</h1>
                </div>
                <div>
                    <story-card class="mt-8" :item="getSuccessStory" :is-read-more="false"></story-card>
                    <hr class="mt-8 border-primary">
                    <div class="mt-8" v-html="getContent"></div>
                </div>
            </div>
        </div>
        <div class="container mx-auto px-8">
            <div class="w-full flex justify-end my-8">
                <back-button></back-button>
            </div>
        </div>
  </section>
</template>

<script>
import gql from 'graphql-tag';
import StoryCard from "../../components/success-stories/StoryCard.vue";
import StoryCardShimmer from "../../components/success-stories/StoryCardShimmer.vue";
import IconBack from "../../components/icons/IconBack.vue";
import backgroundImage from '../../assets/images/success_stories/img1.png';
import BreadCrumb from  "../../components/shared/BreadCrumb.vue";
export default {
    name: "my-success-story",
    props: ["id"],
    components: { 
        StoryCard,
        IconBack,
        StoryCardShimmer,
        BreadCrumb,
    },
    data() {
        return {
            successStories: [],
            breadCrumbItems: [
                { label: 'Home', path: '/' },
                { label: 'Success Stories', path: '/success-stories' },
                { label: 'Story' },
            ],
        };
    },
    computed: {
        backgroundStyle () {
            return {
            'background-image': `url(${backgroundImage})`
            }
        },
        getHeaderText() {
            return this.getSuccessStory.title;
        },
        getSuccessStory() {
            return this.successStories.data[0];
        },
        getContent() {
            return this.getSuccessStory.content;
        },
    },
    apollo: {
        successStories () {
            return {
                query: gql`query GetMySuccessStory($id: ID, $first: Int!, $page: Int!) {
                    successStories(id: $id, first: $first, page: $page) {
                        data {
                            name
                            content
                            description
                            id
                            thumbnail
                            title
                            entity {
                                logo
                                entity
                            }
                        }
                    }
                }`,
                variables () {
                    return {
                        id: this.id,
                        first: 1,
                        page: 1,
                    }
                },
                // fetchPolicy: 'cache-and-network'
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.bg-1 {
  background: linear-gradient(90deg, rgba(34,42,57,1) 0%, rgba(10,66,117,1) 100%);
}
@responsive {
    .ht-auto {
        height: auto;
    }
    .ht-600 {
        height: 600px;
    }
    .ht-500 {
        height: 500px;
    }
    .ht-400 {
        height: 400px;
    }
    .ht-350 {
        height: 350px;
    }
    .ht-300 {
        height: 300px;
    }
}
.bg-image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.text-shadow {
  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
}
</style>